import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-050f67f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editPost" }
const _hoisted_2 = ["onClick"]

import { ref, watchEffect } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import {
  addPostUsingPost,
  editPostUsingPost,
  getPostVoByIdUsingGet,
} from "@/api/postController";
import MdEditor from "@/components/md/MdEditor.vue";
import PostPictureUpload from "@/components/picture/PostPictureUpload.vue";
import TopicSelect from "@/components/selecter/TopicSelecter.vue";

interface Props {
  id: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PostEditPage',
  props: {
    id: { default: () => {
    return 0;
  } }
  },
  setup(__props: any) {

const props = __props;
const router = useRouter();
const form = ref<API.PostAddRequest>({
  imgList: [],
});
const loading = ref(false);
/**
 * 加载数据
 */
const loadData = async () => {
  if (!props.id || props.id == 0) {
    return;
  }
  loading.value = true;
  const response = await getPostVoByIdUsingGet({
    id: props.id,
  });
  if (response.data.code === 0 && response.data.data) {
    form.value = response.data.data;
  } else {
    message.error("加载数据失败，" + response.data.message);
  }
  loading.value = false;
};
/**
 * 监听 searchParams 变量，改变时触发数据的重新加载
 */
watchEffect(() => {
  loadData();
});

/**
 * 创建或修改应用
 */
const submitPost = async () => {
  if (!form.value.content) {
    message.error("内容不能为空");
    return;
  }
  let response: any;
  //添加
  if (!props.id || props.id == 0) {
    response = await addPostUsingPost(form.value);
    //修改
  } else {
    response = await editPostUsingPost({
      id: props.id,
      ...form.value,
    });
  }
  if (response.data.code === 0) {
    message.success("操作成功!");
    router.push(
      `/post/detail/${props.id == 0 ? response.data.data : props.id}`
    );
  } else {
    message.error("操作失败，" + response.data.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_icon_delete = _resolveComponent("icon-delete")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_a_typography_title, { heading: 4 }, {
        default: _withCtx(() => [
          _createTextVNode("写文章")
        ]),
        _: 1
      }),
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_spin, {
            dot: "",
            loading: loading.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "标题" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    modelValue: form.value.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.title) = $event)),
                    placeholder: "请输入帖子标题，最多80字"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "内容" }, {
                default: _withCtx(() => [
                  _createVNode(MdEditor, {
                    modelValue: form.value.content,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.content) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "图片" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_space, { size: "large" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.imgList, (img, index) => {
                        return (_openBlock(), _createBlock(_component_a_image, {
                          key: index,
                          src: img,
                          width: "200"
                        }, {
                          extra: _withCtx(() => [
                            _createElementVNode("span", {
                              class: "action",
                              onClick: ($event: any) => (form.value.imgList.splice(index, 1))
                            }, [
                              _createVNode(_component_icon_delete)
                            ], 8, _hoisted_2)
                          ]),
                          _: 2
                        }, 1032, ["src"]))
                      }), 128)),
                      _withDirectives(_createVNode(PostPictureUpload, {
                        biz: "post_img",
                        "on-change": (url) => form.value.imgList.push(url)
                      }, null, 8, ["on-change"]), [
                        [_vShow, form.value.imgList.length < 3]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "话题" }, {
                default: _withCtx(() => [
                  _createVNode(TopicSelect, {
                    modelValue: form.value.tags,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.tags) = $event)),
                    placeholder: "选择你的话题",
                    limit: 2
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: submitPost
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("提交")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})